import { Bank } from '@app/shared/models/bank';
import { Address } from '@app/shared/models/address';
import { DisplayName } from '@app/shared/components/select/base-select-with-id.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ParticipantTypes } from '@app/shared/models/participant-type';
import { TranslationEntry } from '@app/shared/models/translatable';
import { BaseWithIdList } from '@app/shared/models/list';
import { AddressBookEntry } from '@app/shared/models/address-book-entry';

export class PotentialParticipant extends AddressBookEntry
                                  implements DisplayName {
    public is_company: boolean;
    public bank: Bank;
    public sub_type: string;
    public source: string;

    get displayName() {
        return `${this.name1 ? this.name1 : ''}${this.name2 ? ' ' + this.name2 : ''}${this.name3 ? ' ' + this.name3 : ''}` || '';
    }

    public readonly trans = Object.assign(this.trans, {
        citizen: marker('participant.org.citizen'),
        company: marker('participant.org.company'),
        sub_type: marker('participant.sub_type')
    });

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            type: json && json.type ? [...json.type] : new Array<string>(),
            address: new Address(json && json.address),
            bank: new Bank(json && json.bank)
        });
    }

}

export class PotentialParticipantList extends BaseWithIdList<PotentialParticipant> {

    public participant_type: string;

    constructor(participant_type: string, json?: any) {
        super(PotentialParticipant, json);
        this.participant_type = participant_type;
    }
}


export class Participant extends PotentialParticipant {

    public source_id: string;
    public source: string;
    public case_id: string;
    public type: string[];
    public reference_number: string;
    public modified?: boolean;

    public readonly trans = Object.assign(this.trans, {
        reference_number: marker('participant.reference_number')
    });

    get displayName() {
        return super.displayName;
    }

    public getPrimaryType(): string {
        return this.type[0];
    }

    public getTypeName(): string {
        let name = '';

        for (let i = 0; i < this.type.length; i++) {
            name += `${i === 0 ? '' : ' / '}${this.type[i]}`;
        }

        return name;
    }

    public getMyTypeTranslationKeys(): TranslationEntry[] {
        return this.type.map((type: string) => {
            const translationEntry = ParticipantTypes.getTypeByKey(type) || { key: type, trans: type };
            return translationEntry;
        });
    }

    public isOfType(type: string): boolean {
        return this.type.indexOf(type) > -1;
    }
}

export class Receiver extends Participant {
    public origin: string;
    public origin_id: string;

    constructor(json?: any) {
        super(json);
    }
}

export class ParticipantSummaryObject extends Participant
                                      implements ParticipantSummary {
    public address_phone: string;
    public address_email: string;

    public readonly trans = Object.assign(this.trans, {
        name: marker('participant.name'),
        address_phone: marker('participant.address_phone'),
        address_email: marker('participant.address_email')
    });
}

export interface ParticipantSummary extends DisplayName {
    name1: string;
    name2: string;
    name3: string;
    address_phone: string;
    address_email: string;
    type: string[];

    trans: {
        name: string,
        address_phone: string,
        address_email: string
    };

    isOfType(type: string): boolean;
}
